var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31.837 11.134L21.7493 1.36741","stroke":"#E3232A","strokeWidth":"1.58824","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M22.1026 21.6296L31.8433 11.5168","stroke":"#E3232A","strokeWidth":"1.58824","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M32.0259 11.322L1.18183 11.8604","stroke":"#E3232A","strokeWidth":"1.58824","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ArrowRight.defaultProps = {"width":"33","height":"23","viewBox":"0 0 33 23","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
